export const B2CHerbs = {
  abb: ['bokryeong', 'sansa'],
  aab: ['saenggang', 'geongang'],
  aaa: ['jinpi', 'gamguk'],
  aba: ['eoseongcho', 'ikmocho'],
  bab: ['insam', 'omija'],
  bbb: ['danggwi', 'saenggang'],
  baa: ['jakyak', 'macmoondong'],
  bba: ['sangsimja', 'jakyak'],
  nnn: ['danggwi', 'bokryeong'],
};

export const convertHerb2Korean = {
  sansa: {
    title: '산사차',
    desc: `설명 준비 중`,
  },
  macmoondong: {
    title: '맥문동차',
    desc: `설명 준비 중`,
  },
  changchul: {
    title: '창출차',
    desc: `창출의 주요 유효성분은 β-eudesmol, hinesol, atractylodin 등이 포함되고, 약성은 약간 맵고 따뜻합니다. 효능은 건위작용이 현저하여 위장 안에 습기가 과다하게 쌓여서 일어나는 소화장애와 위장기능 허약증상을 치료하는 데 탁월합니다. 위장장애로 인한 식욕 감소증상, 배가 갑갑하고 헛배가 부르면서 통증을 호소하는 증상에 효과적이며, 특히 위장기능 허약으로 사지가 나른하고 무거우면서 구토나 설사, 이질 등의 증상을 보일 때에 좋은 치료제가 됩니다. 감기에 활용하면 땀을 내게 하고 병원균에 대한 억제효과가 있으며, 풍습성(風濕性)으로 인한 사지관절의 동통과 마비증상을 개선시키기도 합니다. 약리 실험에서는 이뇨 작용, 조혈 자극 작용, 진정(鎭靜) 작용도 입증되었습니다.`,
  },
  bokryeong: {
    title: '복령차',
    desc: `복령은 달고 성질이 온화해요. 
소변을 잘 나오게 해서 부종에 좋고, 신장염, 방광염, 요도염에 효과가 있어요. 
가래를 없애주고 호흡을 편하게 해줘요. 
위장을 강화해서 만성 위장염 증상을 완화하고, 진정작용이 있답니다.`,
  },
  hubak: {
    title: '후박차',
    desc: `복령의 주요 유효성분은 magnolol, honokiol 등이 있으며, 약성은 맵고 따뜻합니다. 기의 순환을 촉진하고 복부가 창만한 것을 낫게 하며 비위를 따뜻하게 하고 습(濕)을 없애며 담(痰)을 삭이는 효능이 있습니다. 헛배부름, 소화 장애, 구토, 설사, 위장염, 위경련, 기침이 나고 숨이 찬 데, 기관지염, 기관지 천식 등에도 쓰입니다. 약리 실험에서 항균 작용, 약한 이뇨작용도 밝혀졌습니다. `,
  },
  gwakhyang: {
    title: '곽향차',
    desc: `곽향의 주요 유효성분으로는 Cis-jasmone, cacetin, β-caryophyllene 등이 있고, 약성은 맵고 약간 따뜻합니다. 비위에 습(濕)이 정체되어 복부창만, 식욕부진, 메스꺼움, 구토, 설사 등을 치료합니다. 소화장애를 동반한 감기, 여름철 식체로 인한 구토, 설사, 구취 등에 효과가 있습니다. 약리 실험에서 위액 분비 촉진 작용, 경미한 발한 작용, 피부 진균, 대장균, 이질균, 폐렴균, 용혈성연쇄상구균 억제작용 등이 밝혀졌습니다.`,
  },
  saenggang: {
    title: '생강차',
    desc: `생강은 맵고 따뜻한 성질을 가지고 있어요. 
감기로 인한 오한, 발열, 두통, 기침, 가래를 치료하며 
식중독으로 인한 복통, 설사에도 효과가 있답니다.`,
  },
  dokhwal: {
    title: '독활차',
    desc: `독활의 주요 유효성분은 continentalic acid, kaurenoic acid 등이 있고, 약성은 온화하며 맛이 쓰고 맵습니다. 진통, 진정 작용 및 혈관확장 작용, 호흡중추를 흥분시키는 작용이 있습니다. 특히 근육통이나 마비에 많이 쓰이는데, 특히 목 주위의 근육이나 허리·척추·무릎의 관절에 통증이 있거나, 하반신에 마비를 일으키는 증상에 효과가 있습니다. 그리고 두통이 심하여 머리가 조이는 듯이 아프고 어지러우며, 혀에는 백태가 끼는 감기증상에도 도움이 됩니다. `,
  },
  jasoyeop: {
    title: '자소엽차',
    desc: `자소엽의 주요 유효성분은 elemicin, perilla aldehyde, vanillic acid, rosmarinic acid methyl ester 등이 있으며, 약성은 맵고 따뜻합니다. 기(氣)가 위로 치밀어 오르는 것을 내리며 한(寒)을 발산시키는 효능이 있어 소화 불량, 발한, 해열, 천식, 기침, 구토 완화 등에 도움을 줍니다. 명치 밑이 불러 오르고 그득한 것과 곽란, 각기 등을 치료하며, 대소변을 잘 나오게 하고 가슴에 있는 담과 기운을 내려가게 합니다. 약리작용으로 항염증 및 항산화작용, 간보호 작용, 기관지 천식 및 알러지성 비염에 대한 작용, 호흡기 뮤신 생성 및 분비 조절작용 등이 밝혀졌습니다. `,
  },
  geongang: {
    title: '말린 생강차',
    desc: `말린 생강은 맵고 뜨거운 성질이 있어요. 
가슴과 배가 차고 아프며, 소화가 안 되고 구토와 설사할 때 좋아요.
또한 맥이 약하고 팔다리가 차갑고 저릴 때, 찬 기운에 기침이 나고 숨이 가쁠 때 도움이 된답니다.`,
  },
  jinpi: {
    title: '귤껍질차',
    desc: `귤껍질은 맵고 쓰며 따뜻한 성질이 있어요.
소화를 돕고 배 부름, 트림, 구토, 메스꺼움을 완화해요. 
설사, 기침, 가래에도 좋고 소변 배출도 도와줍니다. 
몸에 뭉친 기운을 풀어주는 효과도 있어요.`,
  },
  hagocho: {
    title: '하고초차',
    desc: `하고초의 주요 유효성분으로는 ursolic acid, oleanolic acid, rutin hyperoside 등이 있으며, 약성은 맵고 차갑습니다. 간기(肝氣)를 맑게 하고 뭉친 것을 풀어주며, 열을 내리고 독을 제거하며 시력을 좋게하는 효능이 있습니다. 간화(肝火)로 눈이 벌게지면서 붓고 아픈 데, 부종, 대하증 등에 쓰이고, 고혈압증, 폐결핵, 유행성 간염 등에도 쓸 수 있습니다. 약리 실험에서 혈압강하 작용, 이뇨 작용, 항염증 작용, 항균 및 항바이러스 작용 등이 밝혀졌습니다. `,
  },
  gamguk: {
    title: '국화차',
    desc: `국화는 달고 쓰며 차가운 성질이 있어요. 
눈을 시원하게 하고 열을 내려줘요. 
가슴 답답함, 폐렴, 기관지염, 두통, 어깨 결림, 고혈압에 좋아요. 
생리불순과 여드름 같은 피부 문제에도 도움이 된답니다.`,
  },
  geumenhwa: {
    title: '금은화차',
    desc: `금은화의 주요 유효성분으로는 loniceroside C, chlorogenic acid 등이 있고 약성은 달고 차갑습니다. 열을 내리고 가슴이 답답하고 갈증이 있을 때 사용하며, 항염증 효과가 탁월하여 종기, 피부가 헐어 생긴 독, 장기의 염증, 농을 배출하는 데에 효과가 있습니다. 또한 이질, 열독으로 인한 피부 조직 괴사, 유선염 등에도 쓰입니다. 약리작용으로 항균작용, 항염증작용, 해열작용, 백혈구 탐식작용 증가, 중추신경 흥분작용, 혈청 콜레스테롤 강하작용 등이 보고되었습니다.`,
  },
  hwanggeum: {
    title: '황금차',
    desc: `황금의 주요 유효성분은 flavonoid들로 baicalein, biacalin, dihydro-baicalin, wogonin 등이 포함되고, 약성은 쓰고 차갑습니다. 화(火)를 내려주므로 신체에 열이 많고 번조와 갈증을 심하게 나타나는 증상을 개선시키고, 감기로 인한 고열에서부터 일반적인 전염성질환의 고열에 해열효과가 탁월합니다. 체내에 열이 과다하게 쌓여서 일어나는 안구충혈과 통증, 고혈압, 코피, 자궁출혈에도 활용되며, 피부발적 종기에도 효력이 있습니다. 약리실험에서는 항염증작용, 항미생물작용, 해열작용, 이뇨작용, 혈압강하작용, 혈당과 고지혈증강하, 담즙분비 촉진작용, 진정작용 등이 밝혀졌습니다.`,
  },
  ikmocho: {
    title: '익모초차',
    desc: `익모초는 쓰며 서늘한 성질이 있어요. 
혈액 순환을 돕고 몸에 뭉쳐있는 나쁜 피를 풀어줘요. 
자궁 기능을 강화해서 불임증과 여러 부인과 질환에 효과적이에요. 
신장염으로 인한 부종과 혈뇨, 신장결석으로 인한 혈뇨에도 효과가 있답니다.`,
  },
  eoseongcho: {
    title: '어성초차',
    desc: `어성초는 맵고 약간 차가운 성질을 가지고 있어요. 
열을 내리고 고름을 배출하는 데 효과적이에요. 
폐 관련 문제, 장염, 요로감염, 종기 등에 도움이 된답니다.`,
  },
  insam: {
    title: '인삼차',
    desc: `인삼은 달고 약간 쓰며 따뜻한 성질이 있어요. 
원기를 북돋우고 몸의 수분을 보충해줘요. 
허약하거나 피곤할 때 좋고, 식욕 없음, 소화 불량, 구토, 설사에도 효과가 있어요. 
또한 마음을 안정시키고 신경을 진정시키는 데도 도움이 된답니다.`,
  },
  sansuyu: {
    title: '산수유차',
    desc: `산수유는 따뜻한 성질을 가지고 있어요.. 
간과 신장에 좋아서 소변 문제, 어지러움, 이명, 허리와 무릎 통증에 효과가 있어요. 
또한 이뇨작용, 혈압 조절, 소화 개선, 항암, 항균 효과도 있다고 해요.`,
  },
  omija: {
    title: '오미자차',
    desc: `오미자는 온화한 성질을 가지고 있어요. 
심장을 튼튼하게 하고 혈압을 낮추며 면역력을 높여줘요. 
폐 기능을 강화하고 기침, 가래에 좋아 감기 증상 완화에 도움이 된답니다. 입이 마르고 목이 자주 마를 때 효과적이에요. 
또한 시력 개선, 간 보호, 항산화 작용이 있고 심장과 위장 건강에도 좋다고 알려져 있습니다.`,
  },
  danggwi: {
    title: '당귀차',
    desc: `당귀는 달고 맵고 따뜻한 성질이 있어요. 
피를 보충해 주어 빈혈에 좋고, 빈혈로 인한 두통, 관절염, 타박상에 효과적이에요. 
혈액순환을 개선해 월경 조절과 월경통 완화에 도움을 줘요. 또한 변비 해소에도 좋답니다.`,
  },
  baekchul: {
    title: '백출차',
    desc: `백출의 주요 유효성분으로는 atractylone, eudesmol, palmitic acid, hinesol 등이 있으며, 약성은 약간 쓰고 달며 따뜻합니다. 비위허약에 따른 식욕부진, 권태무력, 설사 등의 소화기 기능저하를 치료하는데 쓰입니다. 비위의 기능이 허약해서 소식, 권태감이 생기고 얼굴빛이 황색이며 대변을 묽게 보거나 설사에 좋으며 수분이 정체되어 전신이 붓고 소화가 안 될 때 수분 배설을 돕습니다. 약리적으로 장관 억제작용과 흥분작용을 조절, 항궤양 및 간 보호작용,  면역기능 항진작용, 혈관 확장 작용, 이뇨 작용 및 혈당 강하 작용, 항암 작용 등이 보고되었습니다.`,
  },
  jigolpi: {
    title: '구기자뿌리차',
    desc: `지골피의 주요 성분으로는 cinnamic aldehyde, betaine, kukoaimine 등이 있으며, 약성은 약간 달고 차갑습니다. 몸이 허약하여 생기는 식은땀, 기침, 천식, 토혈, 코피, 소변출혈, 고혈당, 고혈압에 좋으며 신경통, 두통, 어깨통증, 근육통, 요통, 허리와 무릎의 무력감이 있는 경우에도 도움이 됩니다. 약리작용은 심혈관계통의 혈압강하작용, 혈당강하작용 등이 보고되었습니다. `,
  },
  cheonmundong: {
    title: '천문동차',
    desc: `천문동의 주요 성분으로는 asparagine, β-sitosterol 등이 있으며, 약성은 쓰고 차갑습니다. 기침과 가래를 완화하는데 효능이 있어, 만성적인 기침이나 천식으로 인한 기침에도 효과적이며 마른 기침과 객혈에도 도움이 됩니다. 세포와 조직 내 활성산소를 제거하고 손상된 세포를 회복시켜 피부손상에도 효과적입니다. 약리 실험에서 혈압 강하 작용, 혈당 강하 작용, 해열 작용, 항균 작용 등이 보고되었습니다.`,
  },
  jakyak: {
    title: '작약차',
    desc: `작약은 시고 쓰며 차가운 성질이 있어요. 
염증을 줄이고 진정 효과가 있어 장염, 위경련, 복통, 설사에 좋아요. 
혈액순환을 개선해서 월경 문제, 자궁 출혈, 손발 차가움을 완화해줘요. 
또한 빈혈로 인한 근육 경련에도 도움이 된답니다.`,
  },
  sasam: {
    title: '사삼차',
    desc: `사삼의 주요 성분으로는 lupeol, β-sitosterol, stigmasterol, palmitic acid 등이 있으며 약성은 약간 달고 차갑습니다. 열을 내리고 담을 제거하며 고갈된 진액을 생성하여 오래된 해소 천식, 폐결핵으로 가래와 피가 섞여나오는 증상, 혹은 가래가 많고 피가 조금씩 섞여 있는 증상, 미열과 인후 마비 증상, 당뇨로 인한 구갈, 여름의 열로 인한 구갈 등에 효과가 있습니다. 약리학적으로 거담작용, 해열작용, 항진균작용, 강심작용 등이 보고되었습니다.`,
  },
  sangsimja: {
    title: '말린 오디차',
    desc: `말린 오디는 시고 달며 차가운 성질이 있어요. 
간과 신장을 도와 혈액을 보충해줘요. 
당뇨 증상, 입과 혀가 마르는 증상, 어지러움, 불면증에 좋아요. 
또한 장을 부드럽게 해서 혈액 부족으로 인한 변비에도 효과가 있답니다.`,
  },
};

export const B2CDesc = {
  abb: {
    key: 'abb',
    title: '침전물이 쌓이는 강물',
    desc: `당신의 몸은 침전물이 쌓이는 강물 같아요. 외부에서 받는 스트레스가 많고, 노폐물이 잘 처리되지 못해 몸에 누적되고 있어요.
    
요즘 소화가 안 되거나 몸이 자주 붓진 않나요? 체중 조절이 힘들다면, 몸이 에너지를 제대로 쓰지 못하는 신호일 수 있어요.
    
음식으로 스트레스를 해소하지 마시고, 필라테스, 자전거, 조깅 같은 중간 강도의 운동으로 몸의 순환을 돕고 스트레스를 조절해 보세요.
따뜻한 차를 마시는 것도 도움이 된답니다.`,
  },
  aab: {
    key: 'aab',
    title: '퇴근시간의 꽉 막힌 도로',
    desc: `당신의 몸은 퇴근 시간의 꽉 막힌 도로 같아요.
외부 자극에 대한 적절한 대응이 이루어지지 않고 있어요.
    
대변을 보기 힘들거나 소화가 안 되시나요? 
그렇다면 스트레스가 해소되지 않아 발생하는 문제일 수 있어요.

혹시 휴대폰을 사용하시다가 늦게 주무시고 계신다면, 운동이나 명상 같이 다른 스트레스 해소 방법을 찾아야 해요.

다행히 몸속 노폐물이 적고, 에너지 대사도 양호한 편이랍니다. 추위에 주의하면서 규칙적인 생활만 잘 지켜도 건강이 좋아질 거예요!`,
  },
  aaa: {
    key: 'aaa',
    title: '과열된 용광로',
    desc: `당신의 몸은 과열된 용광로 같아요.
    
요즘 화가 자주 나거나, 두통 또는 갈증이 있나요? 그렇다면 몸에서 '열'이 많이 생기거나, 배출되지 못해 발생하는 문제일 수 있어요.

다행히 에너지 대사가 원활하고 노폐물 처리가 양호한 편이랍니다. 긴장이 지속되거나 술을 드시는 경우에 '열'이 더 많아질 수 있어요.

이 유형은 스트레스를 건강하게 해소하는 것이 누구보다 중요해요. 적당한 운동과 충분한 수면을 통해 열을 관리해 보세요. 또한, '열'을 식혀 주는 차를 마시는 것도 도움이 된답니다.`,
  },
  aba: {
    key: 'aba',
    title: '여름날 혼잡한 지하철 ',
    desc: `당신의 몸은 여름날 혼잡한 지하철 같아요.
    
몸 안에 열이 많고 노폐물이 쌓여 있어요. 이는 염증으로 이어질 수 있답니다. 염증은 몸의 방어 체계 중 하나지만, 과하면 건강에 해롭습니다. 피부, 위장, 생식기관뿐 아니라 심장, 간, 신장 등 주요 장기의 기능도 저하될 수 있어요.

이 유형은 염증 관리가 중요해요. 채소와 과일을 풍부하게 섭취하면, 몸속에 쌓인 독소와 노폐물 제거에 도움이 된답니다. 혹시 불편한 증상이 있다면 전문가와 상담해 보세요!`,
  },
  bab: {
    key: 'bab',
    title: '몸집이 작은 경차',
    desc: `당신의 몸은 몸집이 작은 경차 같아요.

큰 차량에 비해 한 번에 사용할 수 있는 연료량이 적어요. 피로 회복이 잘 안 되어서 일상생활에 어려움을 겪을 수 있답니다. 그래서 연료를 효율적으로 사용해야 해요.
    
이 유형은 연비를 최적화하기 위해 충분한 수면을 취하고 영양 섭취에 신경 써주시는 것이 중요해요. 가벼운 스트레칭이나 요가 같은 운동을 통해 혈액 순환을 촉진하는 것도 좋습니다.`,
  },
  bbb: {
    key: 'bbb',
    title: '축 늘어진 식물',
    desc: `당신의 몸은 축 늘어진 식물 같아요.

피곤해서 일상생활이 힘들지 않나요? 몸속 순환과 노폐물 처리가 원활하지 않을 가능성이 커요. 이 유형은 움직이기 싫어하는 경우가 많답니다.

양분 부족으로 약해진 식물같이 당신의 몸은 작은 스트레스에도 쉽게 지칠 수 있어요. 가벼운 몸 풀기나 요가로 혈액 순환을 돕는 게 좋아요. 몸을 따뜻하게 하고 영양 섭취에 신경 써주세요. 노폐물을 배출해 주는 차를 마시는 것도 도움이 된답니다!`,
  },
  baa: {
    key: 'baa',
    title: '메마른 땅',
    desc: `당신의 몸은 메마른 땅 같아요.

힘과 영양분은 바닥났는데 스트레스로 인한 열은 과해요. 이 유형은 호르몬 균형이 무너졌거나 갑상선, 또는 성호르몬에 문제가 생겼을 수 있어요.

손발이나 얼굴이 뜨겁고, 피부와 머리카락이 건조하고 푸석거리지 않나요? 사소한 일에도 심장이 두근거리고, 잠을 잘 못 자는 경우가 많나요? 이건 몸이 심각한 고갈 상태에 있다는 신호일 수 있어요.

수면 시간이 불규칙하거나, 커피 또는 술을 통해 스트레스를 해소한다면 건강 개선이 어렵습니다. 고갈된 자원을 채운다 생각하고 최소 7시간은 꼭 주무세요!`,
  },
  bba: {
    key: 'bba',
    title: '먼지가 날리는 집',
    desc: `당신의 몸은 먼지가 날리는 집 같아요. 활력은 부족한데 온갖 먼지와 쓰레기가 쌓여 있어요.
    
몸이 무겁고 피곤하지 않나요? 머리가 맑지 않고 몸이 자주 붓나요? 이건 몸 안에 노폐물이 너무 많이 쌓였다는 신호일 수 있어요. 

이 유형은 생활 습관 관리가 필요하답니다. 
당 지수가 낮은 식단을 선택하고, 운동은 가볍게 해주세요!`,
  },
  nnn: {
    key: 'nnn',
    title: '맑은 강물',
    desc: `당신의 몸은 맑은 강물처럼 건강해요.
    
막히지 않고 잘 흐르는 강물처럼 최고의 상태입니다. 대사와 혈액 순환이 활발해 나쁜 물질을 잘 처리하고 있어요. 스트레스를 받을 때도 감정 조절을 잘하고 있을 거예요.

이 좋은 상태를 유지하려면 충분한 수면, 균형 잡힌 식사, 적당한 운동이 중요해요. 마음 건강을 위해 독서나 명상도 좋습니다. 이렇게 하면 지금의 건강한 상태를 오래 유지할 수 있을 거예요!`,
  },
};

export const B2CResult = {
  표한허음: {
    title: '표한허음(ECDYi)형',
    img: 'ECDYi',
    desc: `이 유형의 사람들은 외부 환경 변화에 민감하여 감기에 자주 걸리며, 체력이 약하고 에너지가 부족해요. 일상생활에서 쉽게 피로를 느끼며, 정신적으로도 무기력함을 경험하곤 하죠. 따뜻한 환경을 선호하며, 추위를 매우 싫어하는 경향도 있어요.`,
    tip: [
      `찬 바람을 피하고 보온에 신경 쓰며 따뜻한 음식 위주로 드세요. 면역력이 떨어져 있으니 충분한 영양 보충과 수면을 취하는 것이 좋아요.`,
      `체력 향상을 위해 매일 30분씩 자전거 타기나 가벼운 조깅을 하는 것도 도움이 돼요.`,
    ],
    herb: ['계지', '인삼', '생강'],
  },
  표한허양: {
    title: '표한허양(ECDYa)형',
    img: 'ECDYa',
    desc: `이 유형의 사람들은 감기에 걸리기 쉽고, 외부 환경의 변화에 민감하게 반응해요. 추위를 많이 타고 몸이 찬 편이지만, 밝고 활동적인 성향을 가지고 있어요. 일반적으로 신체 활동을 좋아하는 편이지만, 반면 쉽게 지치는 경향이 있답니다.`,
    tip: [
      `활동과 휴식 사이의 균형을 유지하는 것이 중요해요. 과도한 활동보다는 충분한 휴식과 수면을 취하는 것이 필요해요.`,
      `따뜻한 음식 위주로 드시고, 체력 향상을 위해 무리한 운동보다는 가벼운 산책이나 조깅을 추천드려요.`,
    ],
    herb: ['계지', '작약', '생강'],
  },
  표한실음: {
    title: '표한실음(ECEYi)형',
    img: 'ECEYi',
    desc: `이 유형의 사람들은 외부에서 감염된 병이 내부로 침투하면서 몸이 차가워지고 스트레스와 피로가 쌓여 기운이 막힌 상태에요. 면역력 저하로 감기 등 감염성 질환에 자주 걸리는 경향이 있으며, 내부적으로는 노폐물이 쌓여 피로감이 극심하고, 심리적으로도 자주 짜증이 나거나 우울하기도 하죠.`,
    tip: [
      `외부 환경과 스트레스를 조절하여 몸과 마음의 균형을 맞추는 것이 중요해요. 따뜻한 환경에서 휴식을 취하고 스트레스 관리에 주의를 기울여야 해요.`,
      `하루 30분 따뜻한 물에 반신욕을 하거나, 요가나 명상 등을 통해 몸과 마음을 단련하는 것을 추천드려요.`,
    ],
    herb: ['마황', '육계', '방풍'],
  },
  표한실양: {
    title: '표한실양(ECEYa)형',
    img: 'ECEYa',
    desc: `이 유형의 사람들은 외부환경 변화에 민감하여 감기에 걸리기 쉽고, 내부적으로는 스트레스와 노폐물이 쌓여 기가 잘 소통되지 않는 경향이 있어요. 혈액순환이 잘되지 않고, 순환되지 않은 열이 정체되어 자주 불안감을 느끼거나 감정 기복이 심해질 수도 있어요.`,
    tip: [
      `외부 환경과 스트레스를 조절하여 몸과 마음의 균형을 맞추는 것이 중요해요. 평소 요가나 명상 등을 통해 몸의 이완과 정서적인 안정을 함께 도모하는 것이 좋아요.`,
      `혈액순환 및 심신이완을 위해 하루 30분 정도 따뜻한 물에 족욕하는 것도 추천드려요.`,
    ],
    herb: ['육계', '마황', '생강'],
  },
  표열허음: {
    title: '표열허음(EHDYi)형',
    img: 'EHDYi',
    desc: `이 유형의 사람들은 몸의 열 대사가 활발한 편이지만 체력이 부족하고 에너지가 고갈되어 쉽게 지치는 경향이 있어요. 외부환경에 민감하고 면역력이 떨어져 있어서 감기에 자주 걸리고, 스트레스에 민감하여 금방 피로감을 느껴요`,
    tip: [
      `과도한 활동과 스트레스는 정신적인 혼미로 이어질 수 있으니, 충분한 휴식과 수면을 취하는 것이 중요하며 적절한 영양 보충이 반드시 선행되어야 해요.`,
      `무리한 운동보다는 매일 20-30분씩 가벼운 산책부터 시작해서 운동의 강도를 늘리는 것이 좋아요.`,
    ],
    herb: ['생지황', '맥문동', '황련'],
  },
  표열허양: {
    title: '표열허양(EHDYa)형',
    img: 'EHDYa',
    desc: `이 유형의 사람들은 몸의 열 대사가 활발한 편이지만 체력이 부족하고 에너지가 고갈되어 쉽게 지치는 경향이 있어요. 또한 외부환경에 민감하여 스트레스에 취약하고, 면역력이 떨어져 감기에 자주 걸릴 수도 있어요.`,
    tip: [
      `활동과 휴식을 적절히 조절하는 것이 중요하며, 체력과 면역력 개선을 위해 충분한 영양섭취와 수면이 필수적이에요.`,
      `무리한 운동보다는 매일 20-30분씩 가벼운 산책과 명상으로 몸과 마음을 단련하는 것부터 시작해 보세요.`,
    ],
    herb: ['생지황', '천문동', '황금'],
  },
  표열실음: {
    title: '표열실음(EHEYi)형',
    img: 'EHEYi',
    desc: `이 유형의 사람들은 외부의 열이 내부로 쌓여 몸이 뜨겁고 기운이 막혀 있는 상태에요. 자주 화를 내거나 짜증 내기 쉽고, 스트레스가 많은 환경에서는 증상이 더 심해질 수 있어요. 이로 인해 불면증이나 두통, 소화불량 등을 겪을 수도 있어요.`,
    tip: [
      `맵고 기름진 음식은 몸의 열을 조장하므로 피하는 것이 좋으며, 충분한 수분을 섭취하는 것이 좋아요.`,
      `스트레스 관리가 매우 중요하므로 가벼운 운동과 함께 명상이나 심호흡 등을 통해 마음을 안정시키는 것이 도움이 돼요.`,
    ],
    herb: ['황금', '치자', '백지'],
  },
  표열실양: {
    title: '표열실양(EHEYa)형',
    img: 'EHEYa',
    desc: `이 유형의 사람들은 외부의 열이 내부로 쌓여 몸이 뜨겁고 기운이 막혀 있는 상태에요. 자주 화를 내거나 짜증 내기 쉽고, 스트레스가 많은 환경에서는 증상이 더 심해질 수 있어요. 열이 과도하게 쌓이면 쉽게 피로해지며, 두통이나 소화불량, 불면증 등이 발생할 수 있어요.`,
    tip: [
      `맵고 기름진 음식은 몸의 열을 조장하므로 피하는 것이 좋으며, 충분한 수분을 섭취하는 것이 좋아요.`,
      `스트레스 관리 및 충분한 휴식과 수면을 취하는 것이 중요해요. 가벼운 운동과 함께 명상이나 심호흡 등을 통해 몸과 마음을 안정시키는 것이 도움이 돼요.`,
    ],
    herb: ['황련', '치자', '연교'],
  },
  리한허음: {
    title: '리한허음(ICDYi)형',
    img: 'ICDYi',
    desc: `이 유형의 사람들은 혈액순환이 잘되지 않아 몸이 차고 쉽게 피로를 느끼며 면역력도 떨어져 있어요. 소화 기능도 약하고, 특히 추위에 민감하여 자주 감기에 걸리는 편이죠. 심리적으로는 무기력함과 우울감을 느끼기 쉽고, 감정 기복이 심할 수도 있어요.`,
    tip: [
      `평소 몸의 보온에 신경 쓰고, 따뜻한 음식 위주로 드세요. 체력과 면역력이 저하되어 있으므로 충분한 영양 보충과 수면, 휴식을 취하는 것이 중요해요.`,
      `과도한 운동보다는 줌바댄스, 에어로빅 등 가볍고 즐거운 운동을 통해 기운을 북돋아 주는 것이 좋아요.`,
    ],
    herb: ['건강', '육계', '백출'],
  },
  리한허양: {
    title: '리한허양(ICDYa)형',
    img: 'ICDYa',
    desc: `이 유형의 사람들은 내부적으로는 몸이 차가운 편이지만, 비교적 활동적인 성향을 가지고 있어요. 그러나 체력이 약해 쉽게 지치고, 외부의 추위에 민감하게 반응해요. 소화 기능이 약해 식욕부진이나 소화불량, 변비나 설사 등이 나타날 수도 있어요.`,
    tip: [
      `활동과 휴식 사이의 균형을 유지하는 것이 중요해요. 몸의 보온에 신경 쓰고, 소화가 잘 되는 따뜻한 음식 위주로 충분한 영양 보충이 필요해요.`,
      `심리적 안정을 위해 명상이나 가벼운 운동을 통해 기운을 북돋아 주는 것이 좋아요.`,
    ],
    herb: ['인삼', '당귀', '건강'],
  },
  리한실음: {
    title: '리한실음(ICEYi)형',
    img: 'ICEYi',
    desc: `이 유형의 사람들은 내부에 찬 기운이 쌓여 몸이 차갑고, 과도한 스트레스와 체내 노폐물 축적으로 인해 기운이 막혀 있는 상태에요. 이러한 상태는 만성적인 피로와 무기력, 소화장애나 면역력 저하로 이어질 수 있으니 유의해야 해요.`,
    tip: [
      `찬 음식을 멀리하고 몸을 따뜻하게 유지하며, 스트레스를 관리하는 것이 중요해요. 매일 따뜻한 물로 20-30분 정도 반신욕이나 족욕을 통해 혈액순환을 촉진하는 것이 좋아요.`,
      `요가와 명상 등을 통해 심신의 안정을 도모하는 것도 좋습니다.`,
    ],
    herb: ['건강', '육계', '오수유'],
  },
  리한실양: {
    title: '리한실양(ICEYa)형',
    img: 'ICEYa',
    desc: `이 유형의 사람들은 과도한 스트레스와 체내 노폐물 축적으로 인해 혈액순환이 잘되지 않아 기운이 막혀있는 상태에요. 이로 인해 가슴이 답답하거나 금방 피로해지고 감정적으로도 쉽게 화를 내거나 흥분하며 불안감을 느끼기 쉬워요.`,
    tip: [
      `스트레스 관리를 위해 명상이나 심호흡을 꾸준히 하고, 매일 따뜻한 물로 20-30분씩 반신욕이나 족욕을 하며 혈액순환을 촉진시키는 것이 도움이 돼요.`,
      `조깅이나 자전거 타기 등 가벼운 운동을 통해 체력을 단련하고 면역력을 강화시는 것이 좋아요.`,
    ],
    herb: ['창출', '후박', '복령'],
  },
  리열허음: {
    title: '리열허음(IHDYi)형',
    img: 'IHDYi',
    desc: `이 유형의 사람들은 체내 진액이 부족하여 과도한 열감을 느끼거나 피부 건조, 불면증, 변비 등의 증상이 나타날 수 있어요. 체력이 쉽게 고갈되어 피로감을 느끼기 쉬우며 심리적으로 무기력과 우울감을 겪을 수도 있어요.`,
    tip: [
      `충분한 수분 섭취와 영양 보충을 하여 체내 균형을 유지하는 것이 중요해요.`,
      `걷기나 자전거 타기 등 가벼운 운동을 통해 서서히 체력을 기르며 무리하지 않는 것이 좋아요.`,
    ],
    herb: ['지모', '숙지황', '맥문동'],
  },
  리열허양: {
    title: '리열허양(IHDYa)형',
    img: 'IHDYa',
    desc: `이 유형의 사람들은 내부에 열이 쌓여 과도한 열감 느끼거나 소화장애나 변비 등의 증상이 나타날 수 있어요. 면역력이 떨어져 있고 체력이 쉽게 고갈되어 금방 피로해지거나 심리적으로 불안감을 느끼고 감정 기복이 심할 수 있어요.`,
    tip: [
      `맵고 기름진 음식을 멀리하고 소화가 잘 되는 음식 위주로 충분한 영양 보충이 필요해요.`,
      `수분 섭취를 충분히 하고, 걷기나 자전거 타기 등 가벼운 운동을 통해 서서히 체력을 기르며 무리하지 않도록 주의하세요.`,
    ],
    herb: ['생지황', '황백', '지모'],
  },
  리열실음: {
    title: '리열실음(IHEYi)형',
    img: 'IHEYi',
    desc: `이 유형의 사람들은 내부에 과도한 열이 나 노폐물이 쌓여 기운이 막혀 있는 상태에요. 이로 인해 두통이나 불면증, 소화불량 등 다양한 증상이 나타날 수 있어요. 과도한 스트레스나 음주는 증상을 악화시킬 수 있으니 유의해야 해요.`,
    tip: [
      `맵고 기름진 음식, 과도한 음주는 멀리하고 충분한 수분을 섭취하세요.`,
      `명상이나 심호흡을 통해 스트레스를 관리하고 수영이나 요가 등의 운동을 꾸준히 하며 규칙적인 생활을 유지하시는 것을 추천드려요.`,
    ],
    herb: ['대황', '후박', '지실'],
  },
  리열실양: {
    title: '리열실양(IHEYa)형',
    img: 'IHEYa',
    desc: `이 유형의 사람들은 내부에 과도한 열과 노폐물이 쌓여 기운이 막혀 있는 상태에요.  이로 인해 두통이나 소화불량, 변비, 불면증, 불안 초조 등 다양한 증상이 나타날 수 있어요. 과도한 스트레스나 음주는 증상을 악화시킬 수 있으니 유의해야 해요.`,
    tip: [
      `내부의 열을 식히고 정서적 안정을 찾는 것이 중요해요. 맵고 기름진 음식, 과도한 음주는 체내 열을 조장할 수 있으니 자제하시고 충분한 수분을 섭취하세요.`,
      `수영이나 요가, 명상 등을 통해 심신을 단련하고 규칙적인 생활을 유지하시는 것을 추천드려요.`,
    ],
    herb: ['황련', '황백', '치자'],
  },
};

export const herbDesc = {
  계지: {
    img: '',
    desc: `약성은 맵고 달며 따뜻한 편이에요. 기와 혈액 순환을 촉진하며 몸을 따뜻하게 하고, 기운을 북돋아줘요. 약리적으로 해열작용, 진통작용, 강심작용, 항바이러스 작용, 항균작용 등도 있어요.`,
  },
  작약: {
    img: '',
    desc: `약성은 시고 쓰고 약간 차가운 편이에요. 혈액 순환을 촉진하고 근육의 긴장을 완화시켜요. 항염증 및 진정작용이 있어 장염이나 위장의 경련성 통증에 진통효과를 나타내고, 소화장애로 인한 복통, 설사에도 효과가 있어요.`,
  },
  생강: {
    img: '',
    desc: `약성은 맵고 약간 따뜻해요. 감기로 인한 오한, 발열, 기침, 가래, 구토 등을 치료하며 식중독으로 인한 복통, 설사에도 효과가 있어요. 위액분비를 촉진해서 소화에도 도움이 되고, 혈액순환 촉진, 억균 작용 등의 효과도 있어요.`,
  },
  인삼: {
    img: '',
    desc: `약성은 달고 약간 쓰며 따뜻한 편이에요. 원기를 보하고 진액을 생성하여 신체허약, 권태, 피로 등에 효과가 있으며 소화기가 약한 사람들의 식욕부진, 소화불량, 구토, 설사에도 효과가 있어요.`,
  },
  마황: {
    img: '',
    desc: `약성은 맵고 쓰며 성질은 따뜻한 편이에요. 땀구멍을 열어 땀이 나게 하고 기관지 평활근을 이완시켜 하여 감기 증상을 완화해줘요. 또한 위액과 타액분비를 촉진시키고 이뇨작용도 가지고 있어요.`,
  },
  육계: {
    img: '',
    desc: `약성은 맵고 따뜻해요. 몸을 따뜻하게 하여 혈액순환을 촉진하고 어혈을 없애며 통증을 줄여줘요. 비위를 따뜻하게 하여 소화불량이나 설사에도 도움이 되며, 해열작용, 항균작용도 가지고 있어요.`,
  },
  방풍: {
    img: '',
    desc: `약성은 맵고 달며 따뜻해요. 몸의 냉기와 바람을 몰아내는 데 좋아요.  감기로 인한 두통, 오한, 발열, 전신통, 인후통 등에 효과적이에요. 약리적으로 항염증, 해열, 면역활성화, 항균 작용 등이 있어요.`,
  },
  생지황: {
    img: '',
    desc: `약성은 약간 달며 매우 차가운 편이에요. 몸의 열을 식혀 진정시키고, 진액을 생성하며 어혈도 제거해요. 열 나고 가슴이 답답하여 갈증이 나거나 출혈 및 타박상 등에도 효과가 있어요.`,
  },
  맥문동: {
    img: '',
    desc: `약성은 달고 약간 쓰며 찬 편이에요. 몸에 진액을 보충하고 폐를 촉촉하게 하여 마른 기침을 멎게 하고 입마름, 갈증도 해소해요. 소변을 잘 나오게 하며, 변비에도 효과가 있어요.`,
  },
  황련: {
    img: '',
    desc: `약성은 쓰고 차가운 편이에요. 몸의 열을 내려주며, 염증을 완화해요. 약리적으로 장내 세균에 대한 항균작용, 항동맥경화 작용, 소염 작용, 진정작용, 소화액 분비 촉진작용 등이 있어요.`,
  },
  천문동: {
    img: '',
    desc: `약성은 쓰고 차가운 편이에요. 몸의 열을 내리고, 체액을 보충해요. 기침과 가래를 완화하는데 효능이 있고, 객혈에도 도움이 되요. 세포와 조직 내 활성산소를 제거하고 손상된 세포를 회복시켜 피부손상에도 효과적이에요.`,
  },
  황금: {
    img: '',
    desc: `약성은 쓰고 차가워요. 해열작용이 뛰어나 감기로 인한 고열에서부터 일반적인 전염성 질환의 발열에도 효과가 탁월해요. 이 외에도 항염작용, 항균작용, 이뇨작용, 혈압 및 혈당 강하작용 등도 있어요.`,
  },
  치자: {
    img: '',
    desc: `약성은 쓰고 차가워요. 열을 내리고 가슴이 답답한 것을 낫게 해요. 또한 출혈을 멈추고 부종을 가라앉히며 해독시키는 효능이 있어요. 항산화작용, 항염작용, 항당뇨작용 등도 보고 되어있어요.`,
  },
  백지: {
    img: '',
    desc: `약성은 맵고 따뜻해요. 혈액순환을 촉진하며 감기로 인한 두통을 완화하고, 코막힘을 해소하며 염증을 줄여줘요. 약리적으로 진정작용, 진경작용, 항균작용 등이 있어요.`,
  },
  연교: {
    img: '',
    desc: `약성은 쓰고 차가워요. 몸의 열을 내리고 해독하며, 종기나 상처가 부은 것을 가라앉히고 풀어주는 효능이 있어요. 약리적으로 항염작용, 해열작용, 이뇨작용, 항균작용, 지혈작용 등이 있어요.`,
  },
  건강: {
    img: '',
    desc: `약성은 맵고 뜨거워요. 몸을 따뜻하게 하고, 위액분비를 촉진하여 소화를 도와줘요. 배가 차서 소화가 안되며 구토, 설사를 하는 증상에 효과적이에요. 심장을 흥분시켜 혈압을 상승하게 하고 혈액순환을 촉진하는 효능도 있어요.`,
  },
  백출: {
    img: '',
    desc: `약성은 약간 쓰고 달며 따뜻해요. 소화기능을 돕고, 기운을 보강해줘요.  비위 기능 저하에 따른 식욕부진, 소화불량, 권태감, 부종 등에 효과적이에요. 약리적으로 장관 억제작용과 흥분작용을 조절하고 면역항진, 이뇨작용 및 혈당강하작용 등이 있어요.`,
  },
  당귀: {
    img: '',
    desc: `약성은 달고 맵고 따뜻해요. 보혈작용이 탁월하여 빈혈에 효과적이고, 빈혈로 오는 두통이나 관절염, 타박상에도 널리 사용되요. 혈액순환을 개선하여 생리불순이나 생리통에도 효과적이며, 장관운동을 원활하게 해주어 배변에도 도움이 되요.`,
  },
  오수유: {
    img: '',
    desc: `약성은 맵고 뜨거워요. 속을 따뜻하게 하고 기의 순환을 촉진하여 통증을 멎게해요. 소화를 촉진하고 구토를 억제하며, 수분배설을 도와 부종이나 설사에도 효과가 있어요.`,
  },
  창출: {
    img: '',
    desc: `약성은 약간 맵고 따뜻해요. 위장에 습기가 과다하게 쌓여서 나타나는 소화장애를 치료하는데 탁월한 효과가 있어요. 몸이 나른하고 무겁거나, 구토, 설사 등의 증상에도 효과적이에요.`,
  },
  후박: {
    img: '',
    desc: `약성은 맵고 따뜻해요. 기의 순환을 촉진하고 비위를 따뜻하게 하며 습을 없애서 담(痰)을 삭이는 효능이 있어요. 헛배부름, 소화불량, 구토, 설사, 위염, 기관지염에 효과가 있어요.`,
  },
  복령: {
    img: '',
    desc: `약성은 달고 평온해요. 체내의 습기를 제거하고, 신경을 안정시키며 소화기능을 돕고 면역력을 높여줘요. 소변이 잘 나오게 하고 부종, 구토, 설사에도 효과가 있어요.`,
  },
  지모: {
    img: '',
    desc: `약성은 쓰고 달며 차가워요. 몸의 열을 내려주고, 진정 효과가 있어요. 마른 기침, 식은 땀, 뼈가 쑤시고 아픈 증상에 진액을 생성하여 치료하는 효능이 있어요. 약리적으로 해열, 진통, 진정, 억균, 혈당강하 작용이 있어요.`,
  },
  숙지황: {
    img: '',
    desc: `약성은 달고 쓰며 따뜻해요. 혈액과 체액을 보충하여 몸이 허약하여 나타나는 각종 만성병에 효과가 있어요. 요통, 관절통, 월경이상, 어지럼증 등을 치료하고 머리를 검게 하는 효능이 있어요.`,
  },
  황백: {
    img: '',
    desc: `약성은 쓰고 차가워요. 열을 내리고 독을 제거하며 과도한 쌓인 수분 배설을 도와요. 건위작용, 해열작용, 소염작용, 혈압강하 작용, 혈액응고 촉진작용, 소장에 대한 진경작용, 백혈구 탐식기능 증진작용등이 있어요.`,
  },
  대황: {
    img: '',
    desc: `약성은 쓰고 차가워요. 설사를 시켜 체내의 독과 열을 없애는 효능이 있어요. 위와 장을 해독하여 대사를 촉진하여 열성변비와 더부룩한 속을 치료해요. 또한 이뇨작용이 있어 부종을 해소해요.`,
  },
  지실: {
    img: '',
    desc: `약성은 쓰고 시며 차가워요. 막힌 기운을 뚫어주고 소화를 돕고 가래를 삭이는 효능이 있어요. 식체, 복부팽만, 변비, 위염 등에 효과적이고, 자궁 수축작용, 위장 연동운동 항진작용, 강심작용, 이뇨작용 등도 있어요.`,
  },
};
